import { TitleMedium } from '@dh/styles';
import { MandatoryInputHint } from '@dh/components';

export const StepperTitle = ({
    children,
    id,
    isMandatory
}: {
    id?: string;
    children: React.ReactNode;
    isMandatory?: boolean;
}) => {
    if (!isMandatory) {
        return <TitleMedium id={id}>{children}</TitleMedium>;
    } else {
        return (
            <span id={id}>
                <TitleMedium display='inline'>{children}</TitleMedium>
                <MandatoryInputHint display='inline' />
            </span>
        );
    }
};
